import actions from './actions';
import mutations from './mutations';

export default {
  actions,
  mutations,
};
